module.exports = __webpack_public_path__ + "static/img/categories6.8e7c33c.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories6.png
// module id = 8QzD
// module chunks = 1